import React from 'react';
import { Modal as AntdModal } from 'antd';
import { ModalProps } from 'antd/lib';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/pro-regular-svg-icons';

const Modal = ({ children, closeIcon, ...rest }: ModalProps) => {
	return (
		<AntdModal
			{...rest}
			closeIcon={closeIcon === undefined ? (
				<FontAwesomeIcon icon={faX} data-testid="closeModal" />
			) : closeIcon}
		>
			{children}
		</AntdModal>
	);
};

export default Modal;
